<div class="form__block">
  <div class="heading heading_standard heading_centered">Avatar</div>

  <div
    [appIfInvalid]="fc"
    [validationErrors]="{
      required: 'Please, choose avatar',
    }"
  >
    <ng-template [appErrorsHost] />
  </div>

  <label>
    <div class="form__avatar border-radius">
      @let avatarUrl = avatarUrl$ | async;
      <img
        [src]="avatarUrl || 'assets/no-avatar.svg'"
        [width]="avatarUrl ? 100 : 100"
        [height]="avatarUrl ? 100 : 100"
        [alt]="avatarUrl ? 'User Avatar' : 'No Avatar'"
      />

      <label for="select_avatar" class="hidden">select avatar</label>
      <input
        #fileEl
        type="file"
        class="hidden"
        id="select_avatar"
        (change)="onSelectFile($event)"
        accept="image/*"
      />
    </div>
  </label>
</div>
